/*@ngInject*/
const UpdateUserProfileRepository = function (baseRepository, currentUserModel) {

    angular.extend(this, baseRepository);

    this.updateUser = function (data) {
        let url = '/rest/User/' + currentUserModel.getCurrentUser().userId;

        return this.post(url, data);
    };

};

angular.module('umCore')
    .service('updateUserProfileRepository', UpdateUserProfileRepository);
